/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-10 11:44:20
 * @LastEditors: linxi
 * @LastEditTime: 2024-09-03 16:36:39
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Modal, notification, Row, Table } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  EditableColumnType,
  EditableList,
} from '../../compnents/list/EditableList'
import { NavBar } from '../../compnents/nav/NavBar'
import { ThemeContext } from '../../theme/ThemeContext'
import styles from './prescriptionManagement.module.css'
import { useLocation } from 'react-router-dom'
import { getPrescriptionManagementDetailAsync } from './prescriptionManagementSlice'
import { selectSettings } from '../user/setting/settingSlice'
import { Checks } from '../../models/setting'

export const PrescriptionManagementDetail = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const location: any = useLocation()

  const dispatch = useDispatch<RootDispatch>()

  const recipeId = location?.state?.recipeId

  const paymentId = location?.state?.paymentId

  const [detail, setDetail] = useState<any>()

  const settings = useSelector(selectSettings)

  useEffect(() => {
    if (recipeId) {
      dispatch(getPrescriptionManagementDetailAsync({
        recipeId,
      }))
        .then(unwrapResult)
        .then((v: any) => {
          const itemList = v.itemList?.map((item: any, index: number) => ({
            ...item,
            index: index + 1,
          })) || []

          // 按索引奇偶性分成两个数组
          const oddItems = itemList.filter((_: any, index: any) => index % 2 === 0) // 偶数索引（第1,3,5...行）
          const evenItems = itemList.filter((_: any, index: any) => index % 2 === 1) // 奇数索引（第2,4,6...行）
          setDetail({
            ...v,
            itemList,
            oddItems,
            evenItems,
          })
        })
    }
  }, [recipeId || paymentId])

  // 新老目录展示方式
  const getProcuctInfo = (item: any) => {
    const splitTag = item.splitTag
    const accountUnit = item.accountUnit ? item.accountUnit : '-'
    const splitUnit = item.splitUnit ? item.splitUnit : '-'

    // if (settings?.[Checks.MLKG] == 1) {
    //   return splitTag ? splitUnit : accountUnit
    // } else {
      return splitTag ? splitUnit : accountUnit
    // }
  }

  const columns: EditableColumnType<Record<string, any>>[] = [
    {
      title: `序号`,
      key: 'no',
      align: 'center',
      render: (_, t) => t.index,
    },
    {
      title: '药品名称',
      key: 'medicineName',
      align: 'center',
      render: function medicineName(_, t): ReactElement {
        return (
          <div>
            <span>{t.name}/<span>{getProcuctInfo(t)}</span></span>
          </div>
        )
      },
    },
    {
      title: '每帖数量',
      dataIndex: 'countPerTip',
      key: 'countPerTip',
      align: 'center',
    },
    {
      title: '总数量',
      dataIndex: 'drugCount',
      key: 'drugCount',
      align: 'center',
    },
    {
      title: '单价',
      dataIndex: 'retailPrice',
      key: 'retailPrice',
      align: 'center',
      render: (_, t) => t.retailPrice.toFixed(4),
    },
    {
      title: '金额',
      key: 'drugAmount',
      align: 'center',
      render: (_, r) => r.drugAmount?.toFixed(4),
    },
  ]

  return (
    <Col
      style={{
        height: 'calc(100%)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 20px',
      }}
    >
      <NavBar
        where={['处方管理', '处方详情']}
        backtrace={{
          name: '处方管理',
          path: '/prescriptionManagement',
          routeName: '处方管理',
          state: {
            selectKey: location?.state?.selectKey,
          },
        }}
      />
      <Col
        style={{
          flex: 1,
          overflow: 'hidden',
          backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: '20px 35px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <section>
          <>
            <Row className={styles.detail}>
              <Col span={8}>机构名称：{detail?.tenantName || '-'}</Col>
              <Col span={8}>处方单号：{detail?.recipeId || '-'}</Col>
              <Col span={8}>收费时间：{detail?.payTime || '-'}</Col>
            </Row>
            <Row className={styles.detail}>
              <Col span={8}>患者姓名：{detail?.patientName || '-'}</Col>
              <Col span={8}>联系电话：{detail?.patientPhone || '-'}</Col>
              <Col span={8}>诊断：{detail?.disease || '-'}</Col>
            </Row>
            <Row className={styles.detail}>
              <Col span={8}>帖数：{detail?.tip || '-'}</Col>
              <Col span={16}>备注：{detail?.remark || '-'}</Col>
            </Row>
          </>
        </section>
        <Row style={{ height: 'calc(100% - 100px)', overflow: 'auto' }}>
          <Col span={11} style={{ marginRight: '20px' }}>
            <EditableList
              page={{
                items: detail?.oddItems || [],
                current: 1,
                size: 10,
                total: detail?.oddItems?.length || 0,
              }}
              pagination={false}
              style={{ color: theme.tc3 }}
              className={styles.table}
              columns={columns}
            />
          </Col>
          <Col span={12}>
            {detail?.evenItems?.length ? (
              <EditableList
                page={{
                  items: detail?.evenItems || [],
                  current: 1,
                  size: 10,
                  total: detail?.evenItems?.length || 0,
                }}
                pagination={false}
                style={{ color: theme.tc3 }}
                className={styles.table}
                columns={columns}

              />
            ) : null}
          </Col>
        </Row>
        <Row style={{ fontWeight: 'bold', height: '40px', paddingTop: '20px' }}>处方金额：{detail?.totalDrugAmount?.toFixed(2) || '-'}</Row>
      </Col>
    </Col>
  )
}
